module.exports = __webpack_public_path__ + "img/wf.4ee2c9d8.svg";